import {
  HStack,
  PinInput as ChakraPinInput,
  PinInputProps as ChakraPinInputProps,
  PinInputField,
  useColorModeValue,
  PinInputFieldProps,
  BoxProps,
} from "@chakra-ui/react";
import { FC } from "react";

interface PinInputProps extends Omit<ChakraPinInputProps, "children"> {
  limit?: number;
  _field?: PinInputFieldProps;
  _container?: BoxProps;
}

const PinInput: FC<PinInputProps> = (props) => {
  const { limit, size, otp, mask, _field, _container } = props;

  const borderColor = useColorModeValue("#A1A3A2", "white");
  const borderFocusColor = useColorModeValue("secondary.500", "primary.400");

  return (
    <HStack justifyContent="space-evenly" {..._container}>
      <ChakraPinInput otp={otp} type="number" size={size ?? "lg"} placeholder="" {...props} autoFocus={true} mask={mask ?? true}>
        {Array(limit ?? 6)
          .fill(0)
          .map((_, i) => (
            <PinInputField
              key={`pin-input-${i}`}
              w="100%"
              // type="text"
              minH="56px"
              autoComplete="none"
              border="1px solid transparent"
              borderRadius="10px"
              borderColor={borderColor}
              _focus={{
                shadow: "outline",
                borderColor: borderFocusColor,
              }}
              _hover={{
                borderColor: borderFocusColor,
              }}
              {..._field}
            />
          ))}
      </ChakraPinInput>
    </HStack>
  );
};

export default PinInput;
